import * as _ from 'lodash';
import React, { Component } from 'react';
import { Chart } from './Chart'
import './App.css';

import { RevenueModel } from './revenueModel';
import * as strategies from './strategies';

import Cookies from 'js-cookie';

import { 
	Container, 
	Grid, 
	Button, 
	Header, 
	Input, 
	Form, 
	Divider, 
	Icon, 
	Message,
	Statistic
} from 'semantic-ui-react';

class App extends Component 
{
	model;

	globalInterval = null;

	stepInMS = 250;

	charts = {
		revenue: {
			startData: [],
			series: null
		},
		dau: {
			startData: [],
			series: null
		}
	};

	strategy;

	simSpeed = 2;
	startDay = 0;
	kpiInterval = 1;

	constructor()
	{
		super();

		strategies.initialize();

		this.strategy = strategies.getStrategy('realtime');
		this.model = new RevenueModel(this.strategy);

		this.restoreFromCookies(Cookies.get(), this.strategy.config);

		this.state = {
			pauseIcon: 'play',
			currentDay: 0,
			paidDNU: Math.round(this.strategy.config.dailySpend / this.strategy.config.cpi),
			dau: 0,
			revenue: 0,
			revenueSummaryColor: 'black',
			retention: this.generateRetentionSummary()
		};

		//create data up to startDay to skip ahead
		for (let i = 0; i < this.startDay; ++i)
		{
			let d = this.model.step();

			this.charts.dau.startData.push({
				x: d,
				y: this.model.dau
			});

			this.charts.revenue.startData.push({
				x: d,
				y: this.model.totalRevenue
			});
		}

		this.onConfigChanged = _.debounce(this.internalOnConfigChanged, 500);
	}

	generateRetentionSummary()
	{
		let toPercent = (percent, precision) => {
			return (percent * 100).toFixed(precision) + "%";
		};

		let ret = this.model.calculateRetention();
		return {
			d1: toPercent(ret[0], 0),
			d7: toPercent(ret[6], 0),
			d30: toPercent(ret[29], 0),
			d60: toPercent(ret[59], 0),
			d90: toPercent(ret[89], 0),
			d120: toPercent(ret[119], 0),
			d365: toPercent(ret[364], 0)
		}
	}

	componentDidMount()
	{
		this.updateSummary(this.model);
	}

	updateGraphs()
	{
		let reduce = (model, amount) => {
			for (let i = 0; i < amount; ++i)
			{
				let x = model.step();
				if (i === amount - 1)
				{
					return x;
				}	
			}
		};

		let self = this;
		this.globalInterval = setInterval(() => {
			let x = reduce(self.model, self.simSpeed);
			
			let dau = self.model.dau;
			let rev = self.model.totalRevenue;

			self.charts.dau.series.addPoint([x, dau], true);

			self.charts.revenue.series.addPoint([x, rev], true);

			self.updateSummary(self.model);

			//auto stop at each year marker
			if (x >= self.model.config.days || (x > this.simSpeed && x % 365 === this.simSpeed - 1))
			{
				self.togglePause();
			}

		}, this.stepInMS);
	}

	updateSummary(model)
	{
		let dau = model.dau;
		let rev = model.totalRevenue;

		this.setState({
			currentDay: model.stepDay,
			dau: dau,
			revenue: Math.round(rev),
			revenueSummaryColor: rev < 0 ? 'red' : 'green'
		});
	}

	togglePause()
	{
		if (this.globalInterval !== null)
		{
			clearInterval(this.globalInterval);
			this.globalInterval = null;
			this.setState({
				pauseIcon: 'play'
			});
		}
		else
		{
			this.updateGraphs();
			this.setState({
				pauseIcon: 'pause'
			});
		}
	}

	updatePaidDNU()
	{
		this.setState({
			paidDNU: Math.round(this.strategy.config.dailySpend / this.strategy.config.cpi)
		})
	}

	internalOnConfigChanged(type, data)
	{
		let self = this;
		data.value = parseFloat(data.value);
		switch (type)
		{
			case 'speed':
				this.simSpeed = data.value;
				Cookies.set('speed', data.value);
				break;

			case 'stepMS':
				this.stepInMS = data.value;
				Cookies.set('stepMS', data.value);
				break;

			case 'startDay':
				this.startDay = data.value;
				Cookies.set('startDay', data.value);
				location.reload();
				
				break;

			case 'kpiInterval':
				this.kpiInterval = data.value;
				Cookies.set('kpiInterval', data.value);
				break;

			case 'spend':
				this.model.addChangeOverTime('spend', data.value, this.kpiInterval, () => {
					self.updatePaidDNU();
				});
				//this.strategy.config.dailySpend = data.value;
				this.updatePaidDNU();
				Cookies.set('spend', data.value);
				break;

			case 'cpi':
				this.model.addChangeOverTime('cpi', data.value, this.kpiInterval, () => {
					self.updatePaidDNU();
				});
				//this.strategy.config.cpi = data.value;
				this.updatePaidDNU();
				Cookies.set('cpi', data.value);
				break;

			case 'arpdau':
				this.model.addChangeOverTime('arpdau', data.value, this.kpiInterval);
				//this.strategy.config.arpdau = data.value;
				Cookies.set('arpdau', data.value);
				break;

			case 'd1':
				if (isNaN(data.value))
				{
					break;
				}

				if (data.value > 1)
				{
					data.value /= 100;
				}

				this.model.addChangeOverTime('d1', data.value, this.kpiInterval, () => {
					self.setState({
						retention: self.generateRetentionSummary()
					})
				});
				//this.strategy.config.d1 = data.value;
				Cookies.set('d1', data.value);
				break;

			case 'kfactor':
				this.model.addChangeOverTime('kfactor', data.value, this.kpiInterval);
				//this.strategy.config.kfactor = data.value;
				Cookies.set('kfactor', data.value);
				break;

			default:
				break;
		}
		
	}
  
  	render()
	{
		return (
			<div className="App">
			<div id='appheader' className="App-header">
			<h2>Metrics Model Simulator</h2>
			</div>
			<br/><br/>
			<Container>
			<div id='statsSummary'>
				<Statistic.Group widths={3}>
					<Statistic>
						<Statistic.Value>
							<Icon name='calendar' />&nbsp;
							{this.state.currentDay.toLocaleString()}
						</Statistic.Value>
						<Statistic.Label>Day</Statistic.Label>
					</Statistic>
					<Statistic>
						<Statistic.Value>
							<Icon name='users' />&nbsp;
							{this.state.dau.toLocaleString()}
						</Statistic.Value>
						<Statistic.Label>DAU</Statistic.Label>
					</Statistic>
					<Statistic color={this.state.revenueSummaryColor}>
						<Statistic.Value>
							<Icon name='dollar' />&nbsp;
							{this.state.revenue.toLocaleString()}
						</Statistic.Value>
						<Statistic.Label>Total Revenue</Statistic.Label>
					</Statistic>
				</Statistic.Group>
				<br/>
				<Statistic.Group widths={7}>
					<Statistic horizontal value={this.state.retention.d1} label='D1' />
					<Statistic horizontal value={this.state.retention.d7} label='D7' />
					<Statistic horizontal value={this.state.retention.d30} label='D30' />
					<Statistic horizontal value={this.state.retention.d60} label='D60' />
					<Statistic horizontal value={this.state.retention.d90} label='D90' />
					<Statistic horizontal value={this.state.retention.d120} label='D120' />
					<Statistic horizontal value={this.state.retention.d365} label='D365' />
				</Statistic.Group>
				<Divider horizontal>
					<Icon name='dashboard' />
				</Divider>
			</div>
			<Grid>
				<Grid.Column width={4} textAlign='left'>
					<Grid verticalAlign='middle'>
						<Grid.Row columns={2}>
							<Grid.Column width={12}>
								<Header as='h3'>Adjustable Inputs</Header>
							</Grid.Column>
							<Grid.Column width={4} textAlign='right'>
								<Button icon={this.state.pauseIcon} onClick={() => {this.togglePause()}} />
							</Grid.Column>
						</Grid.Row>
					</Grid>
					<Divider horizontal>
						<Icon name='options' />
					</Divider>
					<Form>
						<Form.Field>
							<Input fluid 
								label='Start on Day' 
								placeholder='0' 
								defaultValue={this.startDay}
								onChange={(e, d) => this.onConfigChanged('startDay', d)} />
							<Message size='mini'>Start sim at specific day. Refresh after change.</Message>
						</Form.Field>
						<Form.Field>
							<Input fluid 
								label='Daily Spend'
								placeholder='200' 
								defaultValue={this.strategy.config.dailySpend}
								onChange={(e, d) => this.onConfigChanged('spend', d)}
								disabled={this.state.pauseIcon === 'pause'} />
						</Form.Field>
						<Form.Field>
							<Input fluid 
								label='CPI' 
								placeholder='5' 
								defaultValue={this.strategy.config.cpi}
								onChange={(e, d) => this.onConfigChanged('cpi', d)}
								disabled={this.state.pauseIcon === 'pause'} />
						</Form.Field>
						<Form.Field>
							<Message size='mini'>
								<b>{this.state.paidDNU}</b>
								&nbsp;total paid users per day</Message>
						</Form.Field>
						<Divider />
						<Form.Field>
							<Input fluid 
								label='ARPDAU' 
								placeholder='.35' 
								defaultValue={this.strategy.config.arpdau}
								onChange={(e, d) => this.onConfigChanged('arpdau', d)}
								disabled={this.state.pauseIcon === 'pause'} />
						</Form.Field>
						<Divider />
						<Form.Field>
							<Input fluid 
								label='D1' 
								placeholder='.5' 
								defaultValue={this.strategy.config.d1}
								onChange={(e, d) => this.onConfigChanged('d1', d)}
								disabled={this.state.pauseIcon === 'pause'} />
							<Message size='mini'>D1 retention for new cohorts</Message>
						</Form.Field>
						<Divider />
						<Form.Field>
							<Input fluid 
								label='pK-factor' 
								placeholder='1.5' 
								defaultValue={this.strategy.config.kfactor}
								onChange={(e, d) => this.onConfigChanged('kfactor', d)}
								disabled={this.state.pauseIcon === 'pause'} />
							<Message size='mini'>Number of players each paid player brings in</Message>
						</Form.Field>
						<Divider horizontal>
							<Icon name='settings' />
						</Divider>
						<Form.Field>
							<Input fluid 
								label='KPI Interval' 
								placeholder='7' 
								defaultValue={this.kpiInterval}
								onChange={(e, d) => this.onConfigChanged('kpiInterval', d)}
								disabled={this.state.pauseIcon === 'pause'} />
							<Message size='mini'>Ramp time in days for KPI changes. Change this before changing KPIs.</Message>
						</Form.Field>
						<Form.Field>
							<Input fluid 
								label='Speed' 
								placeholder='2' 
								defaultValue={this.simSpeed}
								onChange={(e, d) => this.onConfigChanged('speed', d)}
								disabled={this.state.pauseIcon === 'pause'} />
							<Message size='mini'>Simulation speed in days</Message>
						</Form.Field>
						<Form.Field>
							<Input fluid 
								label='Day Interval' 
								placeholder='250' 
								defaultValue={this.stepInMS}
								onChange={(e, d) => this.onConfigChanged('stepMS', d)}
								disabled={this.state.pauseIcon === 'pause'} />
							<Message size='mini'>Simulated day interval in milliseconds</Message>
						</Form.Field>
					</Form>
				</Grid.Column>
				<Grid.Column width={12}>
					<div className='chart-area'>
						<Chart id='dauChart' 
							yStartMax={1000} 
							name='Daily Active Users' 
							animation={{duration: 200}}
							data={this.charts.dau}>
						</Chart>
						<Chart id='revenueChart'
							yStartMax={10000} 
							name='Total Revenue' 
							animation={false}
							data={this.charts.revenue}>
						</Chart>
					</div>
				</Grid.Column>
			</Grid>
			</Container>
			</div>
		);
	}

	restoreFromCookies(c, config)
	{
		if (c['spend'])
		{
			config.dailySpend = parseInt(c['spend'], 10);
		}

		if (c['speed'])
		{
			this.simSpeed = parseInt(c['speed'], 10);
		}

		if (c['cpi'])
		{
			config.cpi = parseFloat(c['cpi']);
		}

		if (c['d1'])
		{
			config.d1 = parseFloat(c['d1']);
		}

		if (c['stepMS'])
		{
			this.stepInMS = parseInt(c['stepMS'], 10);
		}

		if (c['arpdau'])
		{
			config.arpdau = parseFloat(c['arpdau']);
		}

		if (c['kfactor'])
		{
			config.kfactor = parseFloat(c['kfactor']);
		}

		if (c['startDay'])
		{
			this.startDay = c['startDay'];
		}

		if (c['kpiInterval'])
		{
			this.kpiInterval = c['kpiInterval'];
		}
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js